<script>
    let imageAd = "./images/iconmenu-ad.svg"
    let imageEvent = "./images/iconmenu-event.svg"
    let imageDonation = "./images/iconmenu-donation.svg"
    let imageCoffee = "./images/iconmenu-coffee.svg"
    let imageTruck = "./images/iconmenu-truck.svg"
    let imageDesign = "./images/iconmenu-design.svg"

    let iconmenuDatas = [
        {id: 1, subject: '광고', link: '#', img: imageAd},
        {id: 2, subject: '카페이벤트', link: '#', img: imageEvent},
        {id: 3, subject: '기부', link: '#', img: imageDonation},
        {id: 4, subject: '커피차', link: '#', img: imageCoffee},
        {id: 5, subject: '푸드트럭', link: '#', img: imageTruck},
        {id: 6, subject: '디자인의뢰', link: '#', img: imageDesign},
    ]

    const goLink = (e) => { 
        e.preventDefault();
    }
</script>

<div class="iconmenu">
    {#each iconmenuDatas as iconmenuData (iconmenuData.id)}
    <button class="iconmenu__item" on:click={goLink}>
        <img src={iconmenuData.img} alt="" />
        <span>{iconmenuData.subject}</span>
    </button>
    {/each}
</div>

<style>
    .iconmenu {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }
    .iconmenu__item {
        padding: 20px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .iconmenu__item img {
        width: 40px;
        height: 40px;
    }
    .iconmenu__item span {
        margin-top: 10px;
    }
</style>